import React, { useContext } from "react";
import styled from "styled-components";
import { AuthContext } from "../../../../../auth-context";
import LocalAtm from "@material-ui/icons/LocalAtm";

const PricingContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media (max-width: 900px) {
    padding: 16px;
  }

  h2,
  h4 {
    margin-bottom: 16px;
  }

  /* h4 {
    background: #fffaed;
    border: 1px solid #F4C136;
    border-radius: 8px;
    box-shadow: 0px 0px 8px 0px #e1e2e6;
    display: block;
    padding: 16px;
  } */
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media (max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const Description = styled.div`
  // border: 1px solid black;
  // padding: 15px;
  color: #3d4148;
  font-size: 1rem;

  @media (max-width: 800px) {
    font-size: 0.8rem;
    height: auto;
  }

  @media (max-width: 1220px) {
    font-size: 0.875rem;
  }

  p {
    margin-bottom: 16px;
  }
`;

const PricingTop = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 700px) {
    height: auto;
  }
`;

const Price = () => {
  const { user } = useContext(AuthContext);

  return (
    <PricingContainer>
      <Label>
        <LocalAtm /> Pricing
      </Label>
      <PricingTop>
        {user.use_flat_rate ? (
          <>
            <h2>${user.monthly_flat_rate} per month</h2>
          </>
        ) : (
          <>
            <h2>${user.account_price} per account</h2>
            <h4>
              {user.accounts.length} out of {user.monthly_peak_basic} seats are
              filled
            </h4>
          </>
        )}
        <Description>
          <p>
            All features and services of Avatar are included for every account.
            This includes access to coaching, the Avatar community, and
            everything else involved with the standard service.
          </p>
          {!user.use_flat_rate && (
            <>
              <p>
                Avatar Nutrition will generate a charge based on the billing
                rate of each covered user and the highest number of covered
                users associated with your account for that billing cycle.
                Charges will be incurred monthly on the billing date renewal.
              </p>
              <p>
                For example, if you add ten clients, then remove two clients a
                week later, you will still pay for ten clients. However, since
                there are only eight clients and the highest number of clients
                that billing cycle was ten, you will not pay for the next two
                clients added for that billing cycle. We refer to these two
                slots as <b>empty seats</b>. When the next billing cycle starts, the
                highest number of clients will reset to the current number of
                covered clients.
              </p>
            </>
          )}
        </Description>
      </PricingTop>
    </PricingContainer>
  );
};

export default Price;
